import axios from 'axios';
import { ROOT_URL, getAuthHeaders, isUnauthorizedError, PAGINATION } from './constants';

// Constantes para el manejo de auditorías en el estado.

// Actualiza los registros de auditoría en el estado.
export const GET_AUDITS = 'GET_AUDITS';
export const GET_AUDIT_CATEGORIES = 'GET_AUDIT_CATEGORIES';
export const GET_AUDIT_ACTIONS = 'GET_AUDIT_ACTIONS';

/**
 * Obtiene los registros de auditoría del sistema.
 *
 * @export getAudits
 * @param pagination : Opciones de paginación (query string: ?page%5Bnumber%5D=1&page%5Bsize%5D=10).
 * @param filters : Objeto con filtros opcionales { category, action, search, dateFrom, dateTo }.
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getAudits(pagination = PAGINATION, filters = {}, successCallback = () => {}, errorCallback = (error) => {}) {
  if (pagination === undefined || pagination === null) {
    pagination = PAGINATION;
  }

  // Construir la URL con los filtros
  const urlObj = new URL(`${ROOT_URL}/audits${pagination}`);

  if (filters.category) {
    urlObj.searchParams.set('category', filters.category);
  }
  if (filters.action) {
    urlObj.searchParams.set('audit_action', filters.action);
  }
  if (filters.search) {
    urlObj.searchParams.set('search', filters.search);
  }
  if (filters.dateFrom) {
    urlObj.searchParams.set('date_from', filters.dateFrom);
  }
  if (filters.dateTo) {
    urlObj.searchParams.set('date_to', filters.dateTo);
  }

  const request = axios.get(urlObj.toString(), getAuthHeaders());

  return (dispatch) => {
    request
      .then(({ data }) => {
        dispatch({
          type: GET_AUDITS,
          payload: data,
        });
        successCallback();
      })
      .catch((error) => {
        if (!isUnauthorizedError(error, dispatch)) {
          errorCallback(error);
        }
      });
  };
}

/**
 * Obtiene las categorías disponibles de auditorías.
 *
 * @export getAuditCategories
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getAuditCategories(successCallback = () => {}, errorCallback = (error) => {}) {
  const request = axios.get(`${ROOT_URL}/audits/categories`, getAuthHeaders());

  return (dispatch) => {
    request
      .then(({ data }) => {
        dispatch({
          type: GET_AUDIT_CATEGORIES,
          payload: data.categories,
        });
        successCallback();
      })
      .catch((error) => {
        if (!isUnauthorizedError(error, dispatch)) {
          errorCallback(error);
        }
      });
  };
}


/**
 * Obtiene las acciones disponibles de auditorías, opcionalmente filtradas por categoría.
 *
 * @export getAuditActions
 * @param category : Categoría para filtrar las acciones (opcional).
 * @param {*} [successCallback=() => {}] : Función a llamar en caso de petición exitosa.
 * @param {*} [errorCallback=(error) => {}] : Función a llamar en caso de una petición con error.
 * @returns Función de manejo de error o éxito de la petición.
 */
export function getAuditActions(category = undefined, successCallback = () => {}, errorCallback = (error) => {}) {
  let url = `${ROOT_URL}/audits/actions`;
  if (category) {
    url = `${url}?category=${encodeURIComponent(category)}`;
  }
  const request = axios.get(url, getAuthHeaders());

  return (dispatch) => {
    request
      .then(({ data }) => {
        dispatch({
          type: GET_AUDIT_ACTIONS,
          payload: data.actions,
        });
        successCallback();
      })
      .catch((error) => {
        if (!isUnauthorizedError(error, dispatch)) {
          errorCallback(error);
        }
      });
  };
}
